// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"WalletList_titleWrapper__dndEu","titleButton":"WalletList_titleButton__1wDza","modalContainer":"WalletList_modalContainer__39w8i"};